module.exports = __webpack_public_path__ + "media/images/weather/104_day-21076fba564c040f93ecbd91a2841351.png";